'use client';
import ImagePreview from '../ImagePreview';
import { Flex } from 'antd';
import Heading from '../Heading';
import { useGlobalStore } from '@/hooks/useGlobalStore';
import useWindowSize from '@/utils/useScreenSize';
import { mobileBreakPoint } from '@/utils/utils';
import RichText from '../RichText';
import {
    PartIntroBlockFragment,
    PartyDateFolderFragment,
    PartyDetailFragment,
    PartyInformationFragment,
} from '@/@types/generated/sitecore';

interface Props {
    content: PartIntroBlockFragment;
    data: {
        partyDateFolder: PartyDateFolderFragment;
        partyDetail: PartyDetailFragment;
        partyInformation: PartyInformationFragment;
    };
}
/** 适用于 pageDetail-PartyIntro  */
const PartyIntro = (props: Props) => {
    // console.log('PartyIntro------', props);
    const { partyInformation } = props.data;
    const globalStore = useGlobalStore();
    const h2Color =
        globalStore.globalSettingData?.masterColorCode?.targetItem?.h2Color?.value || 'none';

    const partyH2Color = partyInformation?.partyColorCode?.targetItem?.h2Color?.value || undefined;

    const isMobile = useWindowSize().width < mobileBreakPoint;
    // const partyFontColor =
    //     partyInformation?.partyColorCode?.targetItem?.fontColor?.value || undefined;

    return (
        <Flex
            vertical={isMobile}
            align={'center'}
            gap={isMobile ? 32 : 60}
            className={'xmd:mb-[48px] xmd:px-[80px] w-full'}
        >
            <div className={'xmd:w-[50%]'}>
                <ImagePreview
                    setting={{
                        src: partyInformation?.partyImage?.src,
                        rootClassName: 'w-full'
                    }}
                />
            </div>

            <Flex vertical gap={15} className='mb-12 px-5 xmd:my-0 xmd:pr-20 xmd:w-[50%]'>
                <Heading
                    level={2}
                    text={props.content?.partyIntroTitle?.value}
                    style={{
                        color: partyH2Color || h2Color,
                    }}
                />
                <RichText html={props.content?.partyIntroContent?.rendered || ''} />
            </Flex>
        </Flex>
    );
};

export default PartyIntro;
